// constants for lib utilites

// identity provider
export const midway = 'midway';
export const gi = 'globalIdentity';
export const cognito = 'cognito';

// stage name
export const prod = 'prod';
//external links
export const CONTACT_US = 'https://w.amazon.com/bin/view/DS2DeviceFarm/ContactUs/';
export const TUTORIAL_URL = 'https://broadcast.amazon.com/channels/37906';

/**
 * Constants for DDF regions
 * @type {{US_WEST_2: string, US_EAST_2: string, US_EAST_2_TAG: string, US_WEST_2_TAG: string, AP_SOUTH_1_TAG: string, AP_SOUTH_1: string}}
 */
export const REGIONS = {
    US_WEST_2: 'us-west-2',
    US_EAST_2: 'us-east-2',
    AP_SOUTH_1: 'ap-south-1',
    US_WEST_2_TAG: 'Oregon',
    US_EAST_2_TAG: 'Ohio',
    AP_SOUTH_1_TAG: 'Mumbai',
};

/**
 * Default region for DDF
 * @type {{regionName: string, regionTag: string}}
 */
export const DEFAULT_REGION = {
    regionName: REGIONS.US_WEST_2,
    regionTag: REGIONS.US_WEST_2_TAG,
};

/**
 * List of supported regions for DDF
 * @type {[{regionName: string, regionTag: string},{regionName: string, regionTag: string},{regionName: string, regionTag: string}]}
 */
export const DDF_REGIONS = [
    DEFAULT_REGION,
    {
        regionName: REGIONS.US_EAST_2,
        regionTag: REGIONS.US_EAST_2_TAG,
    },
    {
        regionName: REGIONS.AP_SOUTH_1,
        regionTag: REGIONS.AP_SOUTH_1_TAG,
    },
];

export const CLIENT_ERROR = 'Client Error';
export const SERVER_ERROR = 'Internal Server Error';
export const AUTHENTICATION_FAILURE = 'Authentication Failed';
export const FEDERATED_USER_FTDF_EXPIRATION = 3600 * 8; // 8 hours
export const OTHER_USER_FTDF_EXPIRATION = 3600; // 1 hour
export const credentials_columns = [
    {
        id: 'access_key_id',
        displayName: 'Access key ID',
    },
    {
        id: 'secret_access_key',
        displayName: 'Secret access key',
    },
    {
        id: 'aws_session_token',
        displayName: 'Session token',
    },
];
